import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as actions from "../../../../actions/customersActions";
import * as componentTypes from "../../../../constants/componentTypes";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as navigationActions from "../../../../actions/navigationActions";
import * as validationHelper from "../../../../helpers/validationHelper";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";
import Customer from "../../../../models/entities/Customer";
import Modal from "../../../global/generic/Modal";
import CancelButton from "../../../global/generic/CancelButton";
import Button from "../../../global/generic/Button";
import Input from "../../../global/generic/Input";

class EditCustomerModal extends Component {
    constructor(props) {
        super(props);

        if (this.props.customer === null) {
            this.state = {
                customerNameInputText: "",
                phoneInputText: "",
                phoneValidation: true,
                emailInputText: "",
                emailValidation: true,
                streetInputText: "",
                cityInputText: "",
                countryInputText: "",
                zipCodeInputText: "",
                barcodeInputText: "",
                marginSelectBoxValue: "none",
                identificationInputText: ""
            };
        } else {
            this.state = {
                customerNameInputText: this.props.customer.name === null ? "" : this.props.customer.name,
                phoneInputText: this.props.customer.phone === null ? "" : this.props.customer.phone,
                emailInputText: this.props.customer.email === null ? "" : this.props.customer.email,
                streetInputText: this.props.customer.street === null ? "" : this.props.customer.street,
                cityInputText: this.props.customer.city === null ? "" : this.props.customer.city,
                countryInputText: this.props.customer.country === null ? "" : this.props.customer.country,
                zipCodeInputText: this.props.customer.zipCode === null ? "" : this.props.customer.zipCode,
                barcodeInputText: this.props.customer.barcode === null ? "" : this.props.customer.barcode,
                phoneValidation:
                    this.props.customer.phone === null
                        ? true
                        : validationHelper.isPhoneValid(this.props.customer.phone),
                emailValidation:
                    this.props.customer.email === null
                        ? true
                        : validationHelper.isEmailValid(this.props.customer.email),
                marginSelectBoxValue: this.props.customer.marginId === null ? "none" : this.props.customer.marginId,
                identificationInputText:
                    this.props.customer.identification === null ? "" : this.props.customer.identification
            };
        }
    }

    componentDidMount = () => {
        if (this.state.emailInputText !== "" && this.state.emailInputText !== null) {
            this.setState({
                emailValidation: validationHelper.isEmailValid(this.state.emailInputText)
            });
        }
        if (this.state.phoneInputText !== "" && this.state.phoneInputText !== null) {
            this.setState({
                phoneValidation: validationHelper.isPhoneValid(this.state.phoneInputText)
            });
        }
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseEditCustomerModalAction();
    };

    handleCustomerNameInputChange = (event) => {
        this.setState({customerNameInputText: event.target.value});
    };

    handlePhoneInputChange = (event) => {
        if (event.target.value === "") {
            this.setState({
                phoneInputText: event.target.value,
                phoneValidation: true
            });
        } else
            this.setState({
                phoneInputText: event.target.value,
                phoneValidation: validationHelper.isPhoneValid(event.target.value)
            });
    };

    handleEmailInputChange = (event) => {
        if (event.target.value === "") {
            this.setState({
                emailInputText: event.target.value,
                emailValidation: true
            });
        } else
            this.setState({
                emailInputText: event.target.value,
                emailValidation: validationHelper.isEmailValid(event.target.value)
            });
    };

    handleStreetInputChange = (event) => {
        this.setState({streetInputText: event.target.value});
    };

    handleCityInputChange = (event) => {
        this.setState({cityInputText: event.target.value});
    };

    handleCountryInputChange = (event) => {
        this.setState({countryInputText: event.target.value});
    };

    handleZipCodeInputChange = (event) => {
        this.setState({zipCodeInputText: event.target.value});
    };

    handleBarcodeInputChange = (event) => {
        this.setState({barcodeInputText: event.target.value});
    };

    handleIdentificationChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value) && event.target.value.length < 20) {
            this.setState({identificationInputText: event.target.value});
        }
    };

    handleOkButtonClick = () => {
        let customer = new Customer(this.props.customer?.id || -1, this.state.customerNameInputText);
        customer.city = this.state.cityInputText.trim().length === 0 ? null : this.state.cityInputText;
        customer.country = this.state.countryInputText.trim().length === 0 ? null : this.state.countryInputText;
        customer.street = this.state.streetInputText.trim().length === 0 ? null : this.state.streetInputText;
        customer.email = this.state.emailInputText.trim().length === 0 ? null : this.state.emailInputText;
        customer.phone = this.state.phoneInputText.trim().length === 0 ? null : this.state.phoneInputText;
        customer.zipCode = this.state.zipCodeInputText.trim().length === 0 ? null : this.state.zipCodeInputText;
        customer.barcode = this.state.barcodeInputText.trim().length === 0 ? null : this.state.barcodeInputText;
        customer.margin = this.state.marginSelectBoxValue === "none" ? null : Number(this.state.marginSelectBoxValue);
        customer.identification =
            this.state.identificationInputText.trim().length === 0 ? null : this.state.identificationInputText;

        if (this.props.customer !== null) {
            this.props.dispatchEditCustomerAction(this.props.tabId, customer);
        } else {
            this.props.dispatchAddCustomerAction(this.props.tabId, customer);
        }
    };

    handleMarginSelectBoxChanged = (event) => {
        this.setState({
            marginSelectBoxValue: event.target.value
        });
    };

    getSelectBoxOptions = () => {
        let options = [];
        options.push(
            <option key="none" value="none">
                -
            </option>
        );

        for (let margin of this.props.marginList) {
            options.push(
                <option key={margin.id} value={margin.id}>
                    {margin.name}
                </option>
            );
        }

        return options;
    };

    getExpirationDate = () => {
        if (!this.props.gdprEnabled || this.props.customer === null || this.props.customer.expirationDate === null) {
            return null;
        }

        return (
            <div className="col-12 flex flex-align-center-vertical">
                <div className="col-4">
                    <Translate value="stock.expirationDate" />:
                </div>
                <div className="col-2">{this.props.customer.formatExpirationDate()}</div>
                <div className="col-6 flex">
                    <span className="flex-right">
                        (
                        <Translate
                            value="customersTab.expiration"
                            name={this.props.customer.name}
                            dayCount={this.props.customer.getExpirationDays()}
                        />
                        )
                    </span>
                </div>
            </div>
        );
    };

    getOkButton = () => {
        let marginValue = this.state.marginSelectBoxValue === "none" ? null : this.state.marginSelectBoxValue;

        if (
            !this.props.customer ||
            this.state.customerNameInputText !== this.props.customer.name ||
            this.state.phoneInputText !== this.props.customer.phone ||
            this.state.emailInputText !== this.props.customer.email ||
            this.state.streetInputText !== this.props.customer.street ||
            this.state.cityInputText !== this.props.customer.city ||
            this.state.countryInputText !== this.props.customer.country ||
            this.state.zipCodeInputText !== this.props.customer.zipCode ||
            this.state.barcodeInputText !== this.props.customer.barcode ||
            marginValue !== this.props.customer.marginId ||
            this.state.identificationInputText !== this.props.customer.identification
        ) {
            if (this.state.customerNameInputText !== "" && this.state.phoneValidation && this.state.emailValidation) {
                return (
                    <Button
                        className="margin-right-5"
                        onClick={this.handleOkButtonClick}
                        svgBefore={imgConfirm}
                        label={<Translate value="general.confirm" />}
                        elementProps={{"data-robot": "confirm-button"}}
                    />
                );
            }
        }
        return (
            <Button
                className="margin-right-5"
                svgBefore={imgConfirm}
                label={<Translate value="general.confirm" />}
                disabled={true}
                elementProps={{"data-robot": "confirm-button"}}
            />
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="font-size-1_5em color-primary padding-bottom-5">
                    <Translate value="customersTab.information" />
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        <Translate value="general.name" />
                        *:
                    </div>
                    <Input
                        className="col-8 primary-input"
                        value={this.state.customerNameInputText}
                        type="text"
                        onChange={this.handleCustomerNameInputChange}
                        elementProps={{"data-robot": "customer-name-input"}}
                    />
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        <Translate value="general.phone" />:
                    </div>
                    <Input
                        className="col-8 primary-input"
                        value={this.state.phoneInputText}
                        type="text"
                        onChange={this.handlePhoneInputChange}
                        isValid={this.state.phoneValidation}
                        elementProps={{"data-robot": "customer-phone-input"}}
                    />
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        <Translate value="general.email" />:
                    </div>
                    <Input
                        className="col-8 primary-input"
                        value={this.state.emailInputText}
                        type="text"
                        onChange={this.handleEmailInputChange}
                        isValid={this.state.emailValidation}
                        elementProps={{"data-robot": "customer-email-input"}}
                    />
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        <Translate value="navigation.navBar.barcode" />:
                    </div>
                    <Input
                        className="col-8 primary-input"
                        value={this.state.barcodeInputText}
                        type="text"
                        onChange={this.handleBarcodeInputChange}
                        elementProps={{"data-robot": "customer-barcode-input"}}
                    />
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        <Translate value="customersTab.identificationNumber" />:
                    </div>
                    <Input
                        className="col-8 primary-input"
                        value={this.state.identificationInputText}
                        type="text"
                        onChange={this.handleIdentificationChange}
                        elementProps={{"data-robot": "customer-identification-input"}}
                    />
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        <Translate value="general.city" />:
                    </div>
                    <Input
                        className="col-8 primary-input"
                        value={this.state.cityInputText}
                        type="text"
                        onChange={this.handleCityInputChange}
                        elementProps={{"data-robot": "customer-city-input"}}
                    />
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        <Translate value="general.street" />:
                    </div>
                    <Input
                        className="col-8 primary-input"
                        value={this.state.streetInputText}
                        type="text"
                        onChange={this.handleStreetInputChange}
                        elementProps={{"data-robot": "customer-street-input"}}
                    />
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        <Translate value="customersTab.zipCode" />:
                    </div>
                    <Input
                        className="col-8 primary-input"
                        value={this.state.zipCodeInputText}
                        type="text"
                        onChange={this.handleZipCodeInputChange}
                        elementProps={{"data-robot": "customer-zipcode-input"}}
                    />
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        <Translate value="general.country" />:
                    </div>
                    <Input
                        className="col-8 primary-input"
                        value={this.state.countryInputText}
                        type="text"
                        onChange={this.handleCountryInputChange}
                        elementProps={{"data-robot": "customer-country-input"}}
                    />
                </div>
                <div className="font-size-1_5em color-primary padding-bottom-5 padding-top-10">
                    <Translate value="customersTab.additionalSettings" />
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="col-4">
                        <Translate value="general.margin" />:
                    </div>
                    <select
                        className="col-8 primary-select"
                        value={this.state.marginSelectBoxValue}
                        onChange={this.handleMarginSelectBoxChanged}
                        data-robot="customer-margin-select"
                    >
                        {this.getSelectBoxOptions()}
                    </select>
                </div>
                {this.getExpirationDate()}
            </React.Fragment>,
            "flex-row-gap-10px flex-wrap slim-scroll col-12"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <div className="flex">
                {this.getOkButton()}
                <CancelButton onClick={this.handleCloseModalClick} elementProps={{"data-robot": "cancel-button"}} />
            </div>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                header={modelHelper.buildModalSection(
                    this.props.customer ? (
                        <Translate value="customersTab.editCustomer" />
                    ) : (
                        <Translate value="customersTab.addCustomer" />
                    )
                )}
                onClose={this.handleCloseModalClick}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "40%", maxWidth: "75%", minHeight: "50%", maxHeight: "90%"}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (ownProps.tabId === undefined || store.customers[ownProps.tabId] === undefined) {
        return {
            customer: null,
            marginList: store.global.customMarginList,
            gdprEnabled: store.settings.gdprEnabled
        };
    }

    return {
        customer: ownProps.params.editMode ? store.customers[ownProps.tabId].customer : null,
        marginList: store.global.customMarginList,
        gdprEnabled: store.settings.gdprEnabled
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseEditCustomerModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.EDIT_CUSTOMER_MODAL));
        },
        dispatchEditCustomerAction: (tabId, customer) => {
            dispatch(actions.editCustomer(tabId, customer));
        },
        dispatchAddCustomerAction: (tabId, customer) => {
            dispatch(actions.addCustomer(tabId, customer));
        }
    };
};

export default EditCustomerModal = connect(mapStoreToProps, mapDispatchToProps)(EditCustomerModal);
